import { css } from 'lit';
import { COLOR } from '@idme/component-utilities';
const LOCAL_COLOR = {
    iconStroke: css `var(--idme-icon-stroke, currentColor)`,
};
export const style = css `
  :host {
    display: inline-block;
  }

  .icon {
    fill: none;
    stroke: ${LOCAL_COLOR.iconStroke};
  }

  .icon--ash {
    --idme-icon-stroke: ${COLOR.ash};
  }

  .icon--gothic {
    --idme-icon-stroke: ${COLOR.gothic};
  }

  .icon--sapphire {
    --idme-icon-stroke: ${COLOR.sapphire};
  }

  .icon--slate {
    --idme-icon-stroke: ${COLOR.slate};
  }

  .icon--stone {
    --idme-icon-stroke: ${COLOR.stone};
  }

  .icon--white {
    --idme-icon-stroke: ${COLOR.white};
  }
`;
//# sourceMappingURL=styles.js.map